import { Col, Overlay, Row, Spinner, Table, Tooltip, Form, Card } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import withFooter from '../../../../components/WithFooter';
import withNavBar from '../../../../components/WithNavBar';
import "./index.scss"
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faClipboardList,
  faEye,
  faPen,
  faTrash,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import COLORS from '../../../../data/colors';
import useBreakpoint from '../../../../hooks/useBreakpoint';
import CustomButton from '../../../../components/CustomButton';
import CustomModal from '../../../../components/CustomModal';
import { useState } from 'react';
import { useRef } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import GET_OUTGOING_NOMINATION from '../../../../graphql/queries/nomination/getOutgoingNomination';
import { StatusNomination } from '../../../../data/statusNomination';
import ACTIVATE_DESTINATION from '../../../../graphql/mutations/nomination/activateDestination';
import REJECT_NOMINATION from '../../../../graphql/mutations/nomination/rejectNomination';
import DELETE_NOMINATION from '../../../../graphql/mutations/nomination/deleteNomination';
import WAITLIST_NOMINATION from '../../../../graphql/mutations/nomination/waitlistNomination';
import DestinationHEIInfo from './DestinationHEIInfo';
import DestinationHEIHeader from './DestinationHEIHeader';
import ExportZip from '../../ExportZip';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import toastConfiguration from "../../../../data/toastConfiguration";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import RelatedIIAsModal from '../../../../components/CustomModal/RelatedIIAsModal';
import CANCEL_NOMINATION from '../../../../graphql/mutations/nomination/cancelNomination';
import EDIT_NOMINATION from '../../../../graphql/mutations/nomination/editNomination';
import { useMemo, useCallback } from 'react';
import GET_ISCED_CODES from '../../../../graphql/queries/IIAs/getISCEDCodes';
import GET_OUNITS from '../../../../graphql/queries/IIAs/getOUnits';
import useUser from '../../../../hooks/useUser';
import GET_HEI_NOMINATIONS from '../../../../graphql/queries/nomination/getHei';
import GET_COUNTRIES from '../../../../graphql/queries/registration/getCountries';

const EditNominationForm = ({ editFormData, onChange, academicYears, dataISCEDCodes, eqfLevels, academicTerms, dataOUnits, dataOUnitsPartner, relatedIIAs, selectedIIA, onIIAChange, genders, countries, statusNomination }) => (
    <Form onKeyDown={(e) => e.stopPropagation()}>
        <Row>
            <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label>First Name <span style={{color: 'red'}}>*</span></Form.Label>
                    <Form.Control
                        type="text"
                        name="field_student_first_name"
                        value={editFormData.field_student_first_name || ''}
                        onChange={onChange}
                        autoComplete="off"
                        isInvalid={!editFormData.field_student_first_name?.trim()}
                        required
                    />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label>Last Name <span style={{color: 'red'}}>*</span></Form.Label>
                    <Form.Control
                        type="text"
                        name="field_student_last_name"
                        value={editFormData.field_student_last_name || ''}
                        onChange={onChange}
                        autoComplete="off"
                        isInvalid={!editFormData.field_student_last_name?.trim()}
                        required
                    />
                </Form.Group>
            </Col>
        </Row>
        
        <Row>
            <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label>Birth Date <span style={{color: 'red'}}>*</span></Form.Label>
                    <Form.Control
                        type="date"
                        name="field_student_birth_date"
                        value={editFormData.field_student_birth_date?.split('T')[0] || ''}
                        onChange={onChange}
                        autoComplete="off"
                        isInvalid={!editFormData.field_student_birth_date?.trim()}
                        required
                    />
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label>Nationality <span style={{color: 'red'}}>*</span></Form.Label>
                    {/* <Form.Control
                        type="text"
                        name="field_student_nationality"
                        value={editFormData.field_student_nationality || ''}
                        onChange={onChange}
                        autoComplete="off"
                        isInvalid={!editFormData.field_student_nationality?.trim()}
                        required
                    /> */}
                    <Form.Select
                        required
                        name="field_student_nationality"
                        value={editFormData.field_student_nationality || ''}
                        onChange={onChange}
                        isInvalid={!editFormData.field_student_nationality?.trim()}
                    >
                        <option value="">Select Nationality</option>
                        {countries.map((country) => (
                            <option key={country.ID} value={country.CountryISO}>
                                {country.CountryISO}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label>Gender <span style={{color: 'red'}}>*</span></Form.Label>
                    {/* <Form.Control
                        type="text"
                        name="field_student_gender"
                        value={editFormData.field_student_gender || ''}
                        // disabled
                        onChange={onChange}
                        // readOnly
                        className="bg-light"
                    /> */}
                    <Form.Select
                        required
                        name="field_student_gender"
                        value={editFormData.field_student_gender || ''}
                        onChange={onChange}
                        isInvalid={!editFormData.field_student_gender?.trim()}
                    >
                        <option value="">Select Gender</option>
                        {genders.map((gender) => (
                            <option key={gender} value={gender}>
                                {gender}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col md={12}>
                <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                        type="email"
                        name="field_student_email"
                        value={editFormData.field_student_email || ''}
                        disabled
                        readOnly
                        className="bg-light"
                    />
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label>Home Erasmus Code</Form.Label>
                    <Form.Control
                        type="text"
                        name="field_home_erasmus_code"
                        value={editFormData.field_home_erasmus_code || ''}
                        disabled
                        readOnly
                        className="bg-light"
                    />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label>Home Org Unit</Form.Label>
                    {/* <Form.Control
                        type="text"
                        name="field_home_org_unit_id"
                        value={editFormData.field_home_org_unit_id || ''}
                        onChange={onChange}
                        autoComplete="off"
                        isInvalid={!editFormData.field_home_org_unit_id?.trim()}
                        required
                    /> */}
                    <Form.Select
                        // required
                        name="field_home_org_unit_id"
                        value={editFormData.field_home_org_unit_id || ''}
                        onChange={onChange}
                        // isInvalid={!editFormData.field_home_org_unit_id?.trim()}
                    >
                        <option value="">Select Home Org Unit</option>
                        {dataOUnits?.ounits?.map((homeOrgUnit) => (
                            <option key={homeOrgUnit.ounit_code} value={homeOrgUnit.ounit_name?.name}>
                                {homeOrgUnit.ounit_name?.name}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label>Host Erasmus Code</Form.Label>
                    <Form.Control
                        type="text"
                        name="field_host_erasmus_code"
                        value={editFormData.field_host_erasmus_code || ''}
                        disabled
                        readOnly
                        className="bg-light"
                    />
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label>Host Org Unit</Form.Label>
                    {/* <Form.Control
                        type="text"
                        name="field_host_org_unit_id"
                        value={editFormData.field_host_org_unit_id || ''}
                        onChange={onChange}
                        autoComplete="off"
                        isInvalid={!editFormData.field_host_org_unit_id?.trim()}
                        required
                    /> */}
                    <Form.Select
                        // required
                        name="field_host_org_unit_id"
                        value={editFormData.field_host_org_unit_id || ''}
                        onChange={onChange}
                        // isInvalid={!editFormData.field_host_org_unit_id?.trim()}
                    >
                        <option value="">Select Host Org Unit</option>
                        {dataOUnitsPartner?.ounits?.map((homeOrgUnit) => (
                            <option key={homeOrgUnit.ounit_code} value={homeOrgUnit.ounit_name?.name}>
                                {homeOrgUnit.ounit_name?.name}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label>Academic Term {statusNomination !== "accepted_by_student" && statusNomination !== "accepted_by_sending" && <span style={{color: 'red'}}>*</span>}</Form.Label>
                    <Form.Select
                        required = {statusNomination !== "accepted_by_student" && statusNomination !== "accepted_by_sending"}
                        name="field_academic_term"
                        value={editFormData.field_academic_term || ''}
                        onChange={onChange}
                        disabled={statusNomination === "accepted_by_student" || statusNomination === "accepted_by_sending"}
                        readOnly={statusNomination === "accepted_by_student" || statusNomination === "accepted_by_sending"}
                        isInvalid={statusNomination !== "accepted_by_student" && statusNomination !== "accepted_by_sending" && !editFormData.field_academic_term?.trim()}
                    >
                        <option value="">Select Academic Term</option>
                        {academicTerms?.map((academicTerm) => (
                            <option key={academicTerm} value={academicTerm}>
                                {academicTerm}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label>Academic Year {statusNomination !== "accepted_by_student" && statusNomination !== "accepted_by_sending" && <span style={{color: 'red'}}>*</span>}</Form.Label>
                    <Form.Select
                        required={statusNomination !== "accepted_by_student" && statusNomination !== "accepted_by_sending"}
                        name="field_academic_year"
                        value={editFormData.field_academic_year || ''}
                        onChange={onChange}
                        disabled={statusNomination === "accepted_by_student" || statusNomination === "accepted_by_sending"}
                        readOnly={statusNomination === "accepted_by_student" || statusNomination === "accepted_by_sending"}
                        isInvalid={statusNomination !== "accepted_by_student" && statusNomination !== "accepted_by_sending" && !editFormData.field_academic_year?.trim()}
                    >
                        <option value="">Select Academic Year</option>
                        {academicYears?.map((academicYear) => (
                            <option key={academicYear} value={academicYear}>
                                {academicYear}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label>Student ISCED {statusNomination !== "accepted_by_student" && statusNomination !== "accepted_by_sending" && <span style={{color: 'red'}}>*</span>}</Form.Label>
                    <Form.Select
                        onChange={onChange}
                        name="field_student_isced"
                        value={editFormData.field_student_isced || ''}
                        isInvalid={statusNomination !== "accepted_by_student" && !editFormData.field_student_isced?.trim()}
                        required={statusNomination !== "accepted_by_student" && statusNomination !== "accepted_by_sending"}
                        disabled={statusNomination === "accepted_by_student" || statusNomination === "accepted_by_sending"}
                        readOnly={statusNomination === "accepted_by_student" || statusNomination === "accepted_by_sending"}
                    >
                        <option value="">Select ISCED Level</option>
                        {dataISCEDCodes?.iscedCodes?.map((el) => (
                            <option key={el.code} value={`${el.code} - ${el.name}`}>
                                {`${el.code} - ${el.name}`}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
            <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label>Student EQF {statusNomination !== "accepted_by_student" && statusNomination !== "accepted_by_sending" && <span style={{color: 'red'}}>*</span>}</Form.Label>
                    <Form.Select
                        onChange={onChange}
                        name="field_student_eqf"
                        value={editFormData.field_student_eqf || ''}
                        isInvalid={statusNomination !== "accepted_by_student" && statusNomination !== "accepted_by_sending" && !editFormData.field_student_eqf?.trim()}
                        required={statusNomination !== "accepted_by_student" && statusNomination !== "accepted_by_sending"}
                        disabled={statusNomination === "accepted_by_student" || statusNomination === "accepted_by_sending"}
                        readOnly={statusNomination === "accepted_by_student" || statusNomination === "accepted_by_sending"}
                    >
                        <option value="">Select EQF Level</option>
                        {eqfLevels?.map((el) => (
                            <option key={el.value} value={el.label}>
                                {el.label}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
        </Row>

        <Row>
            <Col md={12}>
                <Form.Group className="mb-3">
                    <Form.Label>Related IIA</Form.Label>
                    {relatedIIAs && relatedIIAs.length > 0 ? (
                        <Form.Select
                            name="selected_iia"
                            value={selectedIIA || ''}
                            onChange={onIIAChange}
                        >
                            <option value="">Select an IIA</option>
                            {relatedIIAs.map((iia) => (
                                <option key={iia.id} value={iia.id}>
                                    {iia.field_your_iia_id || iia.iia_id || 'N/A'}
                                </option>
                            ))}
                        </Form.Select>
                    ) : (
                        <div className="alert alert-info mb-0">
                            No corresponding IIA(s) found between the home and host institutions.
                        </div>
                    )}
                </Form.Group>
            </Col>
        </Row>

        {selectedIIA && relatedIIAs && (
            <Row>
                <Col md={12}>
                    <SelectedIIADisplay 
                        iia={relatedIIAs.find(i => i.id === selectedIIA)} 
                    />
                </Col>
            </Row>
        )}

        <Row>
            <Col md={12}>
                <Form.Group className="mb-3">
                    <Form.Label>Open Comment</Form.Label>
                    <Form.Control
                        as="textarea"
                        onChange={onChange}
                        name="field_open_comment"
                        value={editFormData.field_open_comment || ''}
                        className="bg-light"
                        disabled={statusNomination === "accepted_by_student" || statusNomination === "accepted_by_sending"}
                        readOnly={statusNomination === "accepted_by_student" || statusNomination === "accepted_by_sending"}
                    />
                </Form.Group>
            </Col>
        </Row>
    </Form>
);

const CooperationConditionCard = ({ condition, index, type, iia }) => {
  const getConditionType = () => {
      if (condition.student_studies && condition.student_studies.length > 0) return 'Student Study';
      if (condition.student_traineeships && condition.student_traineeships.length > 0) return 'Student Traineeship';
      if (condition.staff_teachers && condition.staff_teachers.length > 0) return 'Staff Teacher';
      if (condition.staff_trainings && condition.staff_trainings.length > 0) return 'Staff Training';
      return '';
  };

  const getConditionData = () => {
      if (condition.student_studies && condition.student_studies.length > 0) return condition.student_studies;
      if (condition.student_traineeships && condition.student_traineeships.length > 0) return condition.student_traineeships;
      if (condition.staff_teachers && condition.staff_teachers.length > 0) return condition.staff_teachers;
      if (condition.staff_trainings && condition.staff_trainings.length > 0) return condition.staff_trainings;
      return [];
  };

  const conditionType = getConditionType();
  const conditionData = getConditionData();

  return (
      <Accordion.Item eventKey={index} className="mb-2">
          <Accordion.Header>
              {conditionData.map((item, idx) => {
                  const sendingHeiId = item?.sending_hei_id || 'N/A';
                  const receivingHeiId = item?.receiving_hei_id || 'N/A';
                  const studyFields = item?.subject_area?.map(sa => sa.isced_f_code).join(', ') || 'N/A';
                  
                  return (
                      <div key={idx} style={{ fontSize: '14px', marginBottom: idx < conditionData.length - 1 ? '8px' : '0' }}>
                          <strong>{conditionType}:</strong>{' '}
                          <span style={{ color: '#d63384' }}>{sendingHeiId}</span>
                          {' → '}
                          <span style={{ color: '#d63384' }}>{receivingHeiId}</span>
                          {' / Study Fields: '}
                          <span>{studyFields}</span>
                      </div>
                  );
              })}
          </Accordion.Header>
          <Accordion.Body>
              {conditionData.map((item, idx) => (
                  <div key={idx} className="mb-3 pb-3" style={{ borderBottom: idx < conditionData.length - 1 ? '1px solid #dee2e6' : 'none' }}>
                      <Row>
                          <Col md={6}>
                              <p className="mb-2"><strong>Sending HEI:</strong> {item.sending_hei_id}</p>
                              <p className="mb-2"><strong>Sending Org Unit:</strong> {item.sending_ounit_name || item.sending_ounit_id}</p>
                          </Col>
                          <Col md={6}>
                              <p className="mb-2"><strong>Receiving HEI:</strong> {item.receiving_hei_id}</p>
                              <p className="mb-2"><strong>Receiving Org Unit:</strong> {item.receiving_ounit_name || item.receiving_ounit_id}</p>
                          </Col>
                      </Row>
                      
                      {item.receiving_acad_year && (
                          <p className="mb-2"><strong>Academic Year(s):</strong> {item.receiving_acad_year.join(', ')}</p>
                      )}
                      
                      {item.eqf_level && (
                          <p className="mb-2"><strong>EQF Level(s):</strong> {item.eqf_level.join(', ')}</p>
                      )}
                      
                      <Row>
                          <Col md={6}>
                              <p className="mb-2"><strong>Mobilities per Year:</strong> {item.mobilities_per_year}</p>
                          </Col>
                          <Col md={6}>
                              {item.total_months_per_year && (
                                  <p className="mb-2"><strong>Total Months per Year:</strong> {item.total_months_per_year}</p>
                              )}
                              {item.total_days_per_year && (
                                  <p className="mb-2"><strong>Total Days per Year:</strong> {item.total_days_per_year}</p>
                              )}
                          </Col>
                      </Row>

                      {item.subject_area && item.subject_area.length > 0 && (
                          <div className="mb-2">
                              <strong>Subject Area(s):</strong>
                              <ul className="mb-0 mt-1">
                                  {item.subject_area.map((subject, subIdx) => (
                                      <li key={subIdx}>
                                          {subject.isced_f_code} - {subject.isced_f_code_name}
                                          {subject.isced_clarification && ` (${subject.isced_clarification})`}
                                      </li>
                                  ))}
                              </ul>
                          </div>
                      )}
                  </div>
              ))}
          </Accordion.Body>
      </Accordion.Item>
  );
};

const SelectedIIADisplay = ({ iia }) => {
  if (!iia) return null;

  return (
      <Card className="mb-3 shadow-sm">
          <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">IIA ID: {iia.iia_id || iia.field_your_iia_id || 'N/A'}</h5>
                  <Button
                      className="related-iias-primary-blue"
                      id="view-full-iia-button-edit"
                      onClick={() => window.open("/iias/single-view/" + iia.id, "_blank")}
                  >
                      VIEW FULL IIA
                  </Button>
              </div>

              <Row className="mb-3">
                  <Col md={6}>
                      <p className="mb-2"><strong>Status:</strong> {iia.iia_status ? 'Approved by all' : 'N/A'}</p>
                      <p className="mb-2"><strong>Your IIA ID:</strong> {iia.field_your_iia_id || 'N/A'}</p>
                  </Col>
                  <Col md={6}>
                      <p className="mb-2"><strong>Partner IIA ID:</strong> {iia.field_partner_iia_id || 'N/A'}</p>
                  </Col>
              </Row>

              {iia.cooperation_conditions && (
                  (iia.cooperation_conditions.student_studies?.length > 0 ||
                   iia.cooperation_conditions.student_traineeships?.length > 0 ||
                   iia.cooperation_conditions.staff_teachers?.length > 0 ||
                   iia.cooperation_conditions.staff_trainings?.length > 0) ? (
                      <>
                          <h6 className="mb-3">Cooperation Conditions:</h6>
                          <Accordion>
                              {iia.cooperation_conditions.student_studies && iia.cooperation_conditions.student_studies.length > 0 && (
                                  <CooperationConditionCard 
                                      condition={{ student_studies: iia.cooperation_conditions.student_studies }} 
                                      index={`selected-0`} 
                                      type="outgoing"
                                      iia={iia}
                                  />
                              )}
                              {iia.cooperation_conditions.student_traineeships && iia.cooperation_conditions.student_traineeships.length > 0 && (
                                  <CooperationConditionCard 
                                      condition={{ student_traineeships: iia.cooperation_conditions.student_traineeships }} 
                                      index={`selected-1`} 
                                      type="outgoing"
                                      iia={iia}
                                  />
                              )}
                              {iia.cooperation_conditions.staff_teachers && iia.cooperation_conditions.staff_teachers.length > 0 && (
                                  <CooperationConditionCard 
                                      condition={{ staff_teachers: iia.cooperation_conditions.staff_teachers }} 
                                      index={`selected-2`} 
                                      type="outgoing"
                                      iia={iia}
                                  />
                              )}
                              {iia.cooperation_conditions.staff_trainings && iia.cooperation_conditions.staff_trainings.length > 0 && (
                                  <CooperationConditionCard 
                                      condition={{ staff_trainings: iia.cooperation_conditions.staff_trainings }} 
                                      index={`selected-3`} 
                                      type="outgoing"
                                      iia={iia}
                                  />
                              )}
                          </Accordion>
                      </>
                  ) : (
                      <p className="text-muted">No cooperation conditions available for this IIA.</p>
                  )
              )}
          </Card.Body>
      </Card>
  );
};

const SingleViewOutgoingNominations = () => {
    const { t } = useTranslation('translation', {keyPrefix: 'nominationList.outSignleView'});
    const {user} = useUser();
    const [ size ] = useBreakpoint();
    const tooltipTarget = useRef(null);
    const { id } = useParams();
    const academicYears = [
    "2022/2023",
    "2023/2024",
    "2024/2025",
    "2025/2026",
    "2026/2027",
    "2027/2028",
    "2028/2029",
  ];

    const academicTerms = [
        "First semester (Winter/Autumn)",
        "Second semester (Summer/Spring)",
        "First trimester",
        "Second trimester",
        "Third trimester",
        "Full academic year"
    ];

    const genders = [
        "Male",
        "Female",
        "Undefined"
    ];

    const eqfLevels = [{label: "EQF Level 5 - Associate Degree", value: "5"}, {label: "EQF Level 6 - Bachelor's Degree", value: "6"},
    {label: "EQF Level 7 - Master's Degree", value: "7"}, {label: "EQF Level 8 - Doctorate Degree", value: "8"}];

    const [showTooltip, setShowTooltip] = useState(false);
    const [showModalWaiting, setShowModalWaiting] = useState(false);
    const [showModalReject, setShowModalReject] = useState(false);
    const [showModalCancel, setShowModalCancel] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [showModalNominate, setShowModalNominate] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [mobilityId, setMobilityId] = useState("");
    const [selectedIIA, setSelectedIIA] = useState(null);

    const [editFormData, setEditFormData] = useState({
        field_student_first_name: '',
        field_student_last_name: '',
        field_student_esi: '',
        field_student_birth_date: '',
        field_student_nationality: '',
        field_student_gender: '',
        field_student_email: '',
        field_home_erasmus_code: '',
        field_home_org_unit_id: '',
        field_host_erasmus_code: '',
        field_host_org_unit_id: '',
        field_academic_term: '',
        field_academic_year: '',
        field_student_isced: '',
        field_student_eqf: '',
        field_open_comment: ''
    });

    const { loading, error, data, refetch: refetchQuery } = useQuery(
        GET_OUTGOING_NOMINATION,
        {
          variables: {
            id: id,
          },
        }
    );
    

    const {
        loading: loadingISCEDCodes,
        error: errorISCEDCodes,
        data: dataISCEDCodes,
      } = useQuery(GET_ISCED_CODES);

    const {
        loading: loadingOUnits,
        error: errorOUnits,
        data: dataOUnits,
      } = useQuery(GET_OUNITS, {variables: {heiID: user?.heiID}});

      const {
        loading: loadingOUnitsPartner,
        error: errorOUnitsPartner,
        data: dataOUnitsPartner,
        refetch: refetchPartner
      } = useQuery(GET_OUNITS, {variables: {heiID: ""}});

      const {
                  loading: loadingHostHei,
                  error: errorHostHei,
                  data: dataHostHei,
                  refetch: refetchHostHei
                } = useQuery(GET_HEI_NOMINATIONS, {
              variables: { erasmusCode: "" }
          });

    const {
                loading: loadingCountries,
                error: errorCountries,
                data: dataCountries,
              } = useQuery(GET_COUNTRIES);

    useEffect(() => {
        refetchQuery({
            id: id
        });
      }, []);

      useEffect(() => {
        if (data?.outgoingNomination) {
            const nomination = data.outgoingNomination;
            setEditFormData({
                field_student_first_name: nomination.field_student_first_name || '',
                field_student_last_name: nomination.field_student_last_name || '',
                field_student_esi: nomination.field_student_esi || '',
                field_student_birth_date: nomination.field_student_birth_date || '',
                field_student_nationality: nomination.field_student_nationality || '',
                field_student_gender: nomination.field_student_gender || '',
                field_student_email: nomination.field_student_email || '',
                field_home_erasmus_code: nomination.field_mobility_details?.[0]?.field_home_erasmus_code || '',
                field_home_org_unit_id: nomination.field_mobility_details?.[0]?.field_home_org_unit || '',
                field_host_erasmus_code: nomination.field_mobility_details?.[0]?.field_host_erasmus_code || '',
                field_host_org_unit_id: nomination.field_mobility_details?.[0]?.field_host_org_unit || '',
                field_academic_term: nomination.field_academic_term || '',
                field_academic_year: nomination.field_academic_year || '',
                field_student_isced: nomination.field_student_isced || '',
                field_student_eqf: nomination.field_student_eqf || '',
                field_open_comment: nomination.field_open_comment || ''
            });
            data.outgoingNomination.field_mobility_details[0]?.field_host_erasmus_code && refetchHostHei({
            erasmusCode: data.outgoingNomination.field_mobility_details[0]?.field_host_erasmus_code
        });

            // Set selected IIA if it exists in the nomination
            const homeIiaId = nomination.field_mobility_details?.[0]?.field_home_iia_id;
            if (homeIiaId && nomination.related_iias) {
                const matchingIIA = nomination.related_iias.find(iia => iia.field_your_iia_id === homeIiaId);
                if (matchingIIA) {
                    setSelectedIIA(matchingIIA.id);
                }
            }
        }
    }, [data]);

    const handleIIAChange = useCallback((e) => {
      setSelectedIIA(e.target.value || null);
    }, []);

    // useEffect(() => {
    //     data.outgoingNomination.field_mobility_details[0]?.field_host_erasmus_code && refetchHostHei({
    //         erasmusCode: data.outgoingNomination.field_mobility_details[0]?.field_host_erasmus_code
    //     });
    //   }, [data]);

      useEffect(() => {
        dataHostHei && refetchPartner({
            heiID: dataHostHei?.hei?.heiID
        });
      }, [dataHostHei]);

    const [
        activateDestination, { loading: loadingActivateDestination }
      ] = useMutation(ACTIVATE_DESTINATION);

    const [
        rejectNomination, { loading: loadingRejectNomination }
    ] = useMutation(REJECT_NOMINATION);

    const [
        editNomination, { loading: loadingEditNomination }
    ] = useMutation(EDIT_NOMINATION);

    const [
        cancelNomination, { loading: loadingCancelNomination }
    ] = useMutation(CANCEL_NOMINATION);

    const [
        deleteNomination, { loading: loadingDeleteNomination }
    ] = useMutation(DELETE_NOMINATION);

    const [
        waitlistNomination, { loading: loadingWaitListNomination }
    ] = useMutation(WAITLIST_NOMINATION);

    const handleCloseModalWaiting = () => setShowModalWaiting(false);
    const handleShowModalWaiting = () => setShowModalWaiting(true);
    const handleCloseModalReject = () => setShowModalReject(false);
    const handleShowModalReject = () => setShowModalReject(true);
    const handleCloseModalDelete = () => setShowModalDelete(false);
    const handleCloseModalCancel = () => setShowModalCancel(false);
    const handleShowModalCancel = () => setShowModalCancel(true);
    const handleShowModalDelete = () => setShowModalDelete(true);
    const handleCloseModalNominate = () => setShowModalNominate(false);
    const handleShowModalNominate = () => setShowModalNominate(true);
    const handleShowTooltip = () => setShowTooltip(true);
    const handleCloseTooltip = () => setShowTooltip(false);

    const handleCloseModalEdit = () => setShowModalEdit(false);
    const handleShowModalEdit = () => {
        // Pre-populate form with current data
        setEditFormData({
            field_student_first_name: data.outgoingNomination.field_student_first_name || '',
            field_student_last_name: data.outgoingNomination.field_student_last_name || '',
            field_student_esi: data.outgoingNomination.field_student_esi || '',
            field_student_birth_date: data.outgoingNomination.field_student_birth_date || '',
            field_student_nationality: data.outgoingNomination.field_student_nationality || '',
            field_student_gender: data.outgoingNomination.field_student_gender || '',
            field_student_email: data.outgoingNomination.field_student_email || '',
            field_home_erasmus_code: data.outgoingNomination.field_mobility_details[0]?.field_home_erasmus_code || '',
            field_home_org_unit_id: data.outgoingNomination.field_mobility_details[0]?.field_home_org_unit || '',
            field_host_erasmus_code: data.outgoingNomination.field_mobility_details[0]?.field_host_erasmus_code || '',
            field_host_org_unit_id: data.outgoingNomination.field_mobility_details[0]?.field_host_org_unit || '',
            field_academic_term: data.outgoingNomination.field_academic_term || '',
            field_academic_year: data.outgoingNomination.field_academic_year || '',
            field_student_isced: data.outgoingNomination.field_student_isced || '',
            field_student_eqf: data.outgoingNomination.field_student_eqf || '',
            field_open_comment: data.outgoingNomination.field_open_comment || ''
        });
        setShowModalEdit(true);
    };

    // Make handleInputChange stable with useCallback
    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;
        console.log('Input changed:', name, value);
        setEditFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }, []);

    const handleSaveChanges = async () => {
        try {
            const selectedIIAData = selectedIIA 
                ? data?.outgoingNomination?.related_iias?.find(iia => iia.id === selectedIIA)
                : null;

            const nominationData = {
                field_student_first_name: editFormData.field_student_first_name,
                field_student_last_name: editFormData.field_student_last_name,
                field_student_birth_date: editFormData.field_student_birth_date,
                field_student_gender: editFormData.field_student_gender,
                field_student_nationality: editFormData.field_student_nationality,
                field_home_org_unit: editFormData.field_home_org_unit_id, // Changed from field_home_org_unit_id
                field_host_org_unit: editFormData.field_host_org_unit_id, // Changed from field_host_org_unit_id
                field_academic_term: editFormData.field_academic_term,
                field_academic_year: editFormData.field_academic_year,
                field_student_isced: editFormData.field_student_isced,
                field_student_eqf: editFormData.field_student_eqf,
                field_open_comment: editFormData.field_open_comment,
                ...(selectedIIAData && {
                    field_home_iia_id: selectedIIAData.field_your_iia_id,
                    field_host_iia_id: selectedIIAData.field_partner_iia_id
                })
            };

            await editNomination({
                variables: {
                    editOutgoingNominationId: id,
                    nominationData: nominationData
                }
            });

            handleCloseModalEdit();
            refetchQuery();
            toast.success('Nomination updated successfully!');
        } catch (error) {
            console.error('Error updating nomination:', error);
            toast.error('Failed to update nomination. Please try again.');
        }
    };

    const editModalBody = useMemo(() => (
        <EditNominationForm
            editFormData={editFormData}
            onChange={handleInputChange}
            academicYears={academicYears}
            dataISCEDCodes={dataISCEDCodes}
            eqfLevels={eqfLevels}
            academicTerms={academicTerms}
            dataOUnits={dataOUnits}
            dataOUnitsPartner={dataOUnitsPartner}
            relatedIIAs={data?.outgoingNomination?.related_iias}
            onIIAChange={handleIIAChange}
            selectedIIA={selectedIIA}
            genders={genders}
            countries={dataCountries?.countries}
            statusNomination={data?.outgoingNomination.field_nomination_status}
        />
    ), [editFormData, handleInputChange, academicYears, dataISCEDCodes, eqfLevels, academicTerms, dataOUnits, dataOUnitsPartner, data?.outgoingNomination?.related_iias, handleIIAChange, selectedIIA, genders, dataCountries, data?.outgoingNomination?.field_nomination_status]);

    // Add validation function
    const isFormValid = useMemo(() => {
        const baseRequiredFields = [
            'field_student_first_name',
            'field_student_last_name',
            'field_student_birth_date',
            'field_student_nationality',
            'field_student_gender'
        ];

        // Only add these fields as required if status is NOT "accepted_by_student"
        const conditionalRequiredFields = (data?.outgoingNomination?.field_nomination_status !== 'accepted_by_student' && data?.outgoingNomination?.field_nomination_status !== 'accepted_by_sending') 
            ? [
                'field_academic_term',
                'field_academic_year',
                'field_student_isced',
                'field_student_eqf'
            ] 
            : [];

        const allRequiredFields = [...baseRequiredFields, ...conditionalRequiredFields];

        return allRequiredFields.every(field => {
            const value = editFormData[field];
            return value && value.toString().trim() !== '';
        });
    }, [editFormData, data?.outgoingNomination?.field_nomination_status]);

    if (loading) return (
        <div
            style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)"
            }}
        >
            <Spinner
                as="div"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
                className="align-middle my-auto"
            />
            <span>{t('loadingMessage')}</span>
        </div>
    )
    if (error)
      return (
        <div className="text-center text-danger mx-auto">{t('errorMessage')}</div>
      );

      const field_student_name = (data.outgoingNomination.field_student_first_name && data.outgoingNomination.field_student_last_name) 
      ? `${data.outgoingNomination.field_student_first_name} ${data.outgoingNomination.field_student_last_name}`
      : data.outgoingNomination.field_student_name;
    const field_student_email = data.outgoingNomination.field_student_email;
    const field_student_birth_date = new Date(data.outgoingNomination.field_student_birth_date).toLocaleDateString('en-GB',{
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
    });

    const field_home_hei_name = data.outgoingNomination.field_mobility_details[0]?.field_home_name;
    const field_home_hei_org_unit = data.outgoingNomination.field_mobility_details[0]?.field_home_org_unit;

    const field_home_hei_comment = data.outgoingNomination.field_open_comment;
    const field_student_gender = data.outgoingNomination.field_student_gender;
    const field_student_nationality = data.outgoingNomination.field_student_nationality;
    const field_student_esi = data.outgoingNomination.field_student_esi;
    const field_student_isced = data.outgoingNomination.field_student_isced;
    const field_id = data.outgoingNomination.id;
    const field_student_eqf = data.outgoingNomination.field_student_eqf;
    const field_cv = data.outgoingNomination.field_cv;
    const field_motivation_letter = data.outgoingNomination.field_motivation_letter;
    const field_external_cert = data.outgoingNomination.field_external_cert;
    const field_lang_level = data.outgoingNomination.field_lang_level;
    const field_other_document = data.outgoingNomination.field_other_document;
    const field_academic_year = data.outgoingNomination.field_academic_year;
    const field_academic_term = data.outgoingNomination.field_academic_term;
    const field_reference_contact = data.outgoingNomination.field_reference_contact;
    const field_portfolio = data.outgoingNomination.field_portfolio;
    const field_other_requirement = data.outgoingNomination.field_other_requirement;
    const nominationStatus = data.outgoingNomination.field_nomination_status;
    const createdDate = new Date(data.outgoingNomination.created).toLocaleDateString('en-GB',{
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short'
    });
    const field_home_iia_id = data.outgoingNomination.field_mobility_details[0]?.field_home_iia_id;
    const field_host_iia_id = data.outgoingNomination.field_mobility_details[0]?.field_host_iia_id;

    const handleNominateClick = (element) => {
        handleShowModalNominate(); 
        setMobilityId(element?.id);
    }

    const handleNominate = async () => {
        const toastId = toast.loading(t('applicationFeedback.nominate.loading'), toastConfiguration);
        try {
            const result = await activateDestination({
                variables: {
                  id: mobilityId,
                },
              });
            setShowModalNominate(false);
            if (!result?.errors) {
                toast.update(toastId, {
                    ...toastConfiguration,
                    render: t('applicationFeedback.nominate.success'),
                    type: "success",
                    isLoading: false,
                  });
                refetchQuery({
                    id: id
                });
            }
        } catch (error) {
            if (error) {
                toast.update(toastId, {
                    ...toastConfiguration,
                    render: t('applicationFeedback.nominate.failure'),
                    type: "error",
                    isLoading: false,
                  });
            }
        }
        
        
        
    }

    const handleReject = async () => {
        const toastId = toast.loading(t('applicationFeedback.reject.loading'), toastConfiguration);
        try {
            const result = await rejectNomination({
                variables: {
                  id: field_id,
                },
              });
              setShowModalReject(false);
              if (!result?.errors) {
                toast.update(toastId, {
                    ...toastConfiguration,
                    render: t('applicationFeedback.reject.success'),
                    type: "success",
                    isLoading: false,
                  });
                refetchQuery({
                    id: id
                });
            }
        } catch (error) {
            if (error) {
                toast.update(toastId, {
                    ...toastConfiguration,
                    render: t('applicationFeedback.reject.failure'),
                    type: "error",
                    isLoading: false,
                  });
            }
        }
        
        
    }

    const handleCancel = async () => {
        const toastId = toast.loading("Canceling application...", toastConfiguration);
        try {
            const result = await cancelNomination({
                variables: {
                  id: field_id,
                },
              });
              setShowModalCancel(false);
              if (!result?.errors) {
                toast.update(toastId, {
                    ...toastConfiguration,
                    render: "Succesfully canceled Nomination",
                    type: "success",
                    isLoading: false,
                  });
                refetchQuery({
                    id: id
                });
            }
        } catch (error) {
            if (error) {
                toast.update(toastId, {
                    ...toastConfiguration,
                    render: "Cancelation of nomination failed",
                    type: "error",
                    isLoading: false,
                  });
            }
        }
        
        
    }

    const handleWaitlist = async () => {
        const toastId = toast.loading(t('applicationFeedback.wait.loading'), toastConfiguration);
        try {
            const result = await waitlistNomination({
                variables: {
                  id: field_id,
                },
              });
            setShowModalWaiting(false);
            if (!result?.errors) {
                toast.update(toastId, {
                    ...toastConfiguration,
                    render: t('applicationFeedback.wait.success'),
                    type: "success",
                    isLoading: false,
                  });
                refetchQuery({
                    id: id
                });
            }
        } catch (error) {
            if (error) {
                toast.update(toastId, {
                    ...toastConfiguration,
                    render: t('applicationFeedback.wait.failure'),
                    type: "error",
                    isLoading: false,
                  });
            }
        }
        
        
        
    }

    const handleDelete = async () => {
        const toastId = toast.loading(t('applicationFeedback.delete.loading'), toastConfiguration);
        try {
            const result = await deleteNomination({
                variables: {
                  id: field_id,
                },
              });
              setShowModalDelete(false);
              if (!result?.errors) {
                toast.update(toastId, {
                    ...toastConfiguration,
                    render: t('applicationFeedback.delete.success'),
                    type: "success",
                    isLoading: false,
                  });
                refetchQuery({
                    id: id
                });
            }
        } catch (error) {
            if (error) {
                toast.update(toastId, {
                    ...toastConfiguration,
                    render: t('applicationFeedback.delete.failure'),
                    type: "error",
                    isLoading: false,
                  });
            }
        }
        
    }

  return (
    <>
    {(size !== "xs" && size !== "sm" && size !== "md") && ( <>
    <Row style={ size !== "md" && size !== "lg" && size !== "xl" ? {marginLeft: 35, marginRight: 35} : { marginLeft: 0, marginRight: 0}}>
        <Col style={{marginTop: 75}}>
            <Tabs
            id="application-info"
            >
            <Tab eventKey="home" title={t('applicationInfo.title')} style={{background: "#ffff"}}>
            <Table responsive>
                <thead className='thead-font'>
                    <tr>
                    <th style={{paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>ID</th>
                    <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('applicationInfo.status')}</th>
                    <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('applicationInfo.academicYear')}</th>
                    <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('applicationInfo.academicTerm')}</th>
                    <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('applicationInfo.submissionTime')}</th>
                    <th className='border-hidden'></th>
                    </tr>
                </thead>
                <tbody className='tbody-font'>
                    <tr>
                    <td style={{paddingTop: 0, paddingBottom: 20, paddingLeft: 24}} className='border-hidden body'>{field_id}</td>
                    <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden  body'>{StatusNomination[nominationStatus]}</td>
                    <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden  body'>{field_academic_year}</td>
                    <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden  body'>{field_academic_term}</td>
                    <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden  body'>{createdDate}</td>
                    <td style={{paddingTop: 0, marginTop: -5}} className="download-wrap border-hidden">
                        <Overlay
                            target={tooltipTarget.current}
                            show={showTooltip}
                            placement="top"
                        >
                            {(props) => (
                            <Tooltip
                                id="overlay-example"
                                {...props}
                                className="position-absolute"
                            >
                                    {t('applicationInfo.downloadFiles')}
                            </Tooltip>
                            )}
                        </Overlay>
                        <div ref={tooltipTarget}>
                            <ExportZip id={field_id} onMouseEnter={handleShowTooltip} onMouseLeave={handleCloseTooltip} studentName={field_student_name}/>
                        </div>
                    </td>
                    </tr>
                </tbody>
                </Table>
                <Row style={{textAlign: "right"}}>
                <Col style={{marginBottom: "20px", marginRight: "20px"}}><RelatedIIAsModal nomination={data?.outgoingNomination} type={"outgoing"} /></Col>
                </Row>
            </Tab>
            </Tabs>
        </Col>
    </Row>
    <Row style={size !== "md" && size !== "lg" && size !== "xl" ? {marginLeft: 35, marginRight: 35} : { marginLeft: 0, marginRight: 0}}>
        <Col style={{marginTop: 36}}>
            <Tabs
            id="second-tab"
            >
            <Tab eventKey="general-info" id="general-info" title={t('generalInfo.title')} style={{background: "#EAECF3"}}>
            <Row style={{marginLeft: 5, marginRight: 5}}>
                <Col style={{marginTop: 20, marginBottom: 20}}>
                    <Tabs
                        defaultActiveKey="home"
                        id="student-info"
                        >
                        <Tab eventKey="home" title={t('generalInfo.studentInfo.title')} style={{background: "#ffff"}}>
                            <Table responsive>
                                <thead>
                                    <tr>
                                    <th style={{paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>{t('generalInfo.studentInfo.name')}</th>
                                    <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>BIRTH DATE</th>
                                    <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>GENDER</th>
                                    <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('generalInfo.studentInfo.email')}</th>
                                    <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>NATIONALITY</th>
                                    <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('generalInfo.studentInfo.studyLevel')}</th>
                                    <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{t('generalInfo.studentInfo.studyField')}</th>
                                    </tr>
                                </thead>
                                <tbody className='tbody-font'>
                                    <tr>
                                    <td style={{paddingTop: 0, paddingBottom: 20, paddingLeft: 24}} className='border-hidden body'>{field_student_name}</td>
                                    <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden body'>{field_student_birth_date}</td>
                                    <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden body'>{field_student_gender}</td>
                                    <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden body'>{field_student_email}</td>
                                    <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden body'>{field_student_nationality}</td>
                                    <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden body'>{field_student_eqf}</td>
                                    <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden body'>{field_student_isced}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Tab>
                    </Tabs>
                </Col>
            </Row>
            <Row style={{marginLeft: 5, marginRight: 5}}>
                <Col style={{marginTop: 20, marginBottom: 20}}>
                    <Tabs
                        defaultActiveKey="home"
                        id="student-info"
                        >
                        <Tab eventKey="home" title={"HOME HEI"} style={{background: "#ffff"}}>
                            <Table responsive>
                                <thead>
                                    <tr>
                                    <th style={{paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>{"NAME"}</th>
                                    <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{"ORGANIZATIONAL UNIT"}</th>
                                    <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>{"COMMENT FROM HOME HEI"}</th>
                                    </tr>
                                </thead>
                                <tbody className='tbody-font'>
                                    <tr>
                                    <td style={{paddingTop: 0, paddingBottom: 20, paddingLeft: 24}} className='border-hidden body'>{field_home_hei_name}</td>
                                    <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden body'>{field_home_hei_org_unit}</td>
                                    <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden body'>{field_home_hei_comment}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Tab>
                    </Tabs>
                </Col>
            </Row>

            {(field_home_iia_id || field_host_iia_id) && (
                <Row style={{marginLeft: 5, marginRight: 5}}>
                    <Col style={{marginTop: 20, marginBottom: 20}}>
                        <Tabs
                            defaultActiveKey="home"
                            id="iia-info"
                            >
                            <Tab eventKey="home" title="IIA INFORMATION" style={{background: "#ffff"}}>
                                <Table responsive>
                                    <thead>
                                        <tr>
                                        <th style={{paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className='border-hidden label-style'>HOME IIA ID</th>
                                        <th style={{paddingTop: 15, paddingBottom: 2}} className='border-hidden label-style'>HOST IIA ID</th>
                                        <th className='border-hidden'></th>
                                        </tr>
                                    </thead>
                                    <tbody className='tbody-font'>
                                        <tr>
                                        <td style={{paddingTop: 0, paddingBottom: 20, paddingLeft: 24}} className='border-hidden body'>{field_home_iia_id || 'N/A'}</td>
                                        <td style={{paddingTop: 0, paddingBottom: 20}} className='border-hidden body'>{field_host_iia_id || 'N/A'}</td>
                                        <td style={{paddingTop: 0, paddingBottom: 20, textAlign: 'right', paddingRight: 24}} className='border-hidden'>
                                            {(() => {
                                                const matchingIIA = data?.outgoingNomination?.related_iias?.find(
                                                    iia => iia.field_your_iia_id === field_home_iia_id || iia.field_partner_iia_id === field_home_iia_id
                                                );
                                                return matchingIIA ? (
                                                    <Button
                                                        className="related-iias-primary-blue"
                                                        id="view-full-iia-button"
                                                        onClick={() => window.open("/iias/single-view/" + matchingIIA.id, "_blank")}
                                                    >
                                                        VIEW FULL IIA
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        className="related-iias-primary-blue"
                                                        id="view-full-iia-button"
                                                        disabled
                                                    >
                                                        VIEW FULL IIA
                                                    </Button>
                                                );
                                            })()}
                                        </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Tab>
                        </Tabs>
                    </Col>
                </Row>
            )}
            <Row style={{marginLeft: 5, marginRight: 5}}>
                <Col style={{marginTop: 20, marginBottom: 20}}>
                    <Tabs
                        defaultActiveKey="home"
                        id="destination-heis"
                        >
                        <Tab eventKey="home" title={t('generalInfo.destinationheis.title')} style={{background: "#ffff"}}>
                            <Table  responsive="xl">
                                <thead>
                                    <tr className='thead-font d-flex' >
                                    <th style={{paddingTop: 15, paddingBottom: 2, paddingLeft: 24}} className="col-xl-3 col-lg-3 border-hidden label-style">{t('generalInfo.destinationheis.institutionFaculty')}</th>
                                    {/* <th style={{paddingTop: 15, paddingBottom: 2, paddingRight: 0}} className="col-xl-3 col-lg-2 border-hidden label-style">AVAILABLE SPOTS</th> */}
                                    <th style={{paddingTop: 15, paddingBottom: 2, paddingLeft: 0}} className="col-xl-2 col-lg-2 border-hidden label-style">{t('generalInfo.destinationheis.nominatedStudents')}</th>
                                    {/* <th style={size === "lg" || size === "xl"? {paddingTop: 15, paddingBottom: 2, paddingLeft: 0} : {paddingTop: 15, paddingBottom: 2, paddingLeft: 0, justifyContent: "center", display: "flex"}} className="col-xl-2 col-lg-2 border-hidden label-style">DURATION</th> */}
                                    {/* <th  className="col-xl-2 col-lg-3 border-hidden"></th> */}
                                    {nominationStatus === "rejected_by_receiving" &&<th style={{paddingTop: 15, paddingBottom: 2, paddingLeft: 0}} className="col-xl-2 col-lg-2 border-hidden label-style">Rejection Comment by the Receiving Institution</th>}

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colSpan="6" className='border-hidden'>
                                        {/* <Accordion defaultActiveKey="0" className='border-hidden'> */}
                                            {data.outgoingNomination?.field_mobility_details?.map((element, index) =>
                                            <> 
                                                {/* <Accordion.Item eventKey={index} className='border-hidden'>
                                                    <Accordion.Header className='border-hidden'> */}
                                                        <DestinationHEIHeader size={size} nominationStatus={nominationStatus} mobilityDetail={element} academicYear={field_academic_year} handleNominate={handleNominateClick} isMobile={false}/>
                                                    {/* </Accordion.Header> */}
                                                    {/* <Accordion.Body className='border-hidden grey'> */}
                                                        {/* <DestinationHEIInfo hostErasmusCode={element?.field_host_erasmus_code} isMobile={false}/> */}
                                                    {/* </Accordion.Body> */}
                                                {/* // </Accordion.Item> */}
                                            {data.outgoingNomination?.field_mobility_details.length - 1 !== index && <hr style={{marginLeft: 18, marginRight: 20, border: "2px solid #DDDDDD"}}/>}
                                            </>
                                            )}
                                    {/* </Accordion> */}
                                    </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Tab>
                    </Tabs>
                </Col>
                </Row>
                
            </Tab>
            {(field_cv?.id || field_portfolio?.id || field_external_cert?.id || field_reference_contact?.id || field_motivation_letter?.id || field_lang_level?.length > 0 || field_other_document?.length > 0) && <Tab eventKey="documents" id="documents" title={t('documents.title')} style={{background: "#EAECF3"}}>
            <Row style={{marginLeft: 25, marginRight: 25}}>
                <Col style={{marginTop: 30, marginBottom: 12}} md={12} lg={12}>
                {(field_cv?.id) &&
                <>
                    <Col style={{marginBottom: 12, paddingRight: 3}} md={12} lg={12}>
                        <div className='document-item label-style'><span style={{float: "left", paddingLeft: 17}}>CV</span>
                            <div style={{marginBottom: 12, float: "right", marginRight: 20}}>
                            <a href={`/applications-for-erasmus+/outgoing-students/export/${id}/${field_cv?.id}`} target="_blank" rel="noreferrer">
                                <CustomButton buttonType={"primary"} text={t('documents.viewPdf')} small={true} icon={faEye} hasIcon={true} iconColor={COLORS.white}/>
                            </a>
                            </div>
                        </div>
                    </Col>
                </>
                }

                {(field_portfolio?.id) &&
                <>
                    <Col style={{marginBottom: 12, paddingRight: 3}} md={12} lg={12}>
                        <div className='document-item label-style'><span style={{float: "left", paddingLeft: 17}}>{t('documents.files.portfolio')}</span>
                            <div style={{marginBottom: 12, float: "right", marginRight: 20}}>
                                <a href={`/applications-for-erasmus+/outgoing-students/export/${field_portfolio?.id}`} target="_blank" rel="noreferrer">
                                    <CustomButton buttonType={"primary"} text={t('documents.viewPdf')} small={true} icon={faEye} hasIcon={true} iconColor={COLORS.white}/>
                                </a>
                            </div>
                        </div>
                    </Col>
                </>
                }

                {(field_external_cert?.id) &&
                <>
                    <Col style={{marginBottom: 12, paddingRight: 3}} md={12} lg={12}>
                        <div className='document-item label-style'><span style={{float: "left", paddingLeft: 17}}>{t('documents.files.externalCertification')}</span>
                            <div style={{marginBottom: 12, float: "right", marginRight: 20}}>
                                <a href={`/applications-for-erasmus+/outgoing-students/export/${id}/${field_external_cert?.id}`} target="_blank" rel="noreferrer">
                                    <CustomButton buttonType={"primary"} text={t('documents.viewPdf')} small={true} icon={faEye} hasIcon={true} iconColor={COLORS.white}/>
                                </a>
                            </div>
                        </div>
                    </Col>
                </>
                }
                {(field_reference_contact?.id) && 
                <>
                    <Col style={{marginBottom: 12, paddingRight: 3}} md={12} lg={12}>
                        <div className='document-item label-style'><span style={{float: "left", paddingLeft: 17}}>{t('documents.files.referenceContact')}</span>
                            <div style={{marginBottom: 12, float: "right", marginRight: 20}}>
                                <a href={`/applications-for-erasmus+/outgoing-students/export/${id}/${field_reference_contact?.id}`} target="_blank" rel="noreferrer">
                                    <CustomButton buttonType={"primary"} text={t('documents.viewPdf')} small={true} icon={faEye} hasIcon={true} iconColor={COLORS.white}/>
                                </a>
                            </div>
                        </div>
                    </Col>
                </>
                }
                
                {(field_motivation_letter?.id) &&
                <>
                    <Col style={{marginBottom: 12, paddingRight: 3}} md={12} lg={12}>
                        <div className='document-item label-style'><span style={{float: "left", paddingLeft: 17}}>{t('documents.files.motivationLetter')}</span>
                            <div style={{marginBottom: 12, float: "right", marginRight: 20}}>
                                <a href={`/applications-for-erasmus+/outgoing-students/export/${id}/${field_motivation_letter?.id}`} target="_blank" rel="noreferrer">
                                    <CustomButton buttonType={"primary"} text={t('documents.viewPdf')} small={true} icon={faEye} hasIcon={true} iconColor={COLORS.white}/>
                                </a>
                            </div>
                        </div>
                    </Col>
                </>
                }

                {(field_lang_level?.length > 0) &&
                <>
                    
                    <Accordion className='border-hidden label-style' style={{marginBottom: 12}}>
                        <Accordion.Item eventKey="0" className='label-style'>
                            <Accordion.Header className='document-item label-style'>{t('documents.files.languageCert')}</Accordion.Header>
                            <Accordion.Body className='border-hidden label-style'>
                                {field_lang_level.map((element, index) => 
                                <Col style={{marginBottom: 12, paddingRight: 3, background: "#F2F3F6"}} md={12} lg={12}>
                                <div className='document-language-item label-style'><span style={{float: "left", paddingLeft: 13}}>{element?.fileName}</span>
                                    <div style={{marginBottom: 12, float: "right", marginRight: 20}}>
                                        <a href={`/applications-for-erasmus+/outgoing-students/export/${id}/${element?.id}`} target="_blank" rel="noreferrer">
                                            <CustomButton buttonType={"primary"} text={t('documents.viewPdf')} small={true} icon={faEye} hasIcon={true} iconColor={COLORS.white}/>
                                        </a>
                                    </div>
                                </div>
                                </Col>
                                )}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </>
                }

                {(field_other_document?.length > 0) &&
                <>
                    
                    <Accordion className='border-hidden label-style' style={{marginBottom: 12}}>
                        <Accordion.Item eventKey="0" className='label-style'>
                            <Accordion.Header className='document-item label-style'>{t('documents.files.other')}</Accordion.Header>
                            <Accordion.Body className='border-hidden label-style'>
                                {field_other_document.map((element, index) => 
                                <Col style={{marginBottom: 12, paddingRight: 3, background: "#F2F3F6"}} md={12} lg={12}>
                                <div className='document-language-item label-style'><span style={{float: "left", paddingLeft: 13}}>{element?.fileName}</span>
                                    <div style={{marginBottom: 12, float: "right", marginRight: 20}}>
                                        <a href={`/applications-for-erasmus+/outgoing-students/export/${id}/${element?.id}`} target="_blank" rel="noreferrer">
                                            <CustomButton buttonType={"primary"} text={t('documents.viewPdf')} small={true} icon={faEye} hasIcon={true} iconColor={COLORS.white}/>
                                        </a>
                                    </div>
                                </div>
                                </Col>
                                )}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </>
                }
                </Col>
            </Row>
            </Tab>}
            </Tabs>
        </Col>
    </Row>
    <Row style={size !== "md" && size !== "lg" ? {marginLeft: 35, marginRight: 35} : { marginLeft: 0, marginRight: 0}}>
        <Col style={{marginTop: 36, display: "flex", justifyContent: "flex-end"}}>
            {nominationStatus === "rejected_by_student" && <><CustomButton buttonType={"primary"} text={t('waitingList')} icon={faClipboardList} hasIcon={true} iconColor={COLORS.white} disabled={(nominationStatus === 'accepted_by_sending' 
            || nominationStatus === 'accepted_by_student' || nominationStatus === 'rejected_by_sending' || nominationStatus === 'cancelled' ) ? true : (nominationStatus === 'waiting_list') ? 
            true : (nominationStatus === 'rejected_by_student') ? true : false} handleClick={handleShowModalWaiting}/>
            <CustomButton buttonType={"decline"} text={t('reject')} styles={{marginLeft: 20}} icon={faXmark} hasIcon={true} iconColor={COLORS.white} disabled={(nominationStatus === 'accepted_by_sending' 
            || nominationStatus === 'accepted_by_student' || nominationStatus === 'rejected_by_sending' || nominationStatus === 'cancelled' ) ? true : (nominationStatus === 'waiting_list') ? 
            false : (nominationStatus === 'rejected_by_student') ? true : false} handleClick={handleShowModalReject}/>
            <CustomButton buttonType={"delete"} text={t('delete')} styles={{marginLeft: 20}} icon={faTrash} hasIcon={true} iconColor={COLORS.white} disabled={(nominationStatus === 'accepted_by_sending' 
            || nominationStatus === 'accepted_by_student' || nominationStatus === 'rejected_by_sending' || nominationStatus === 'cancelled' ) ? true : (nominationStatus === 'waiting_list') ? 
            false : (nominationStatus === 'rejected_by_student') ? false : false} handleClick={handleShowModalDelete}/></>}
            {(nominationStatus === "rejected_by_receiving" || nominationStatus === "accepted_by_student" || nominationStatus === "accepted_by_sending") && <CustomButton 
                        buttonType={"orange"} 
                        text={"Edit"} 
                        styles={{marginRight: 20}} 
                        handleClick={handleShowModalEdit}
                        icon={faPen}
                        hasIcon={true}
                        iconColor={COLORS.white}
                    />}
            <CustomButton buttonType={"delete"} text={"CANCEL"} styles={{marginLeft: 20}} icon={faXmark} hasIcon={true} iconColor={COLORS.white} disabled={(nominationStatus === 'cancelled' ? true : false)} handleClick={handleShowModalCancel}/>
        </Col>
    </Row>
</>
  )}
  {(size === "xs" || size === "sm" || size === "md") && (
    <>
    <Row style={{marginLeft: 2, marginRight: 5}}>
        <Col style={{marginTop: 15, paddingLeft: 0, paddingRight: 0}} xs={12} sm={12}>
            <Tabs
            id="application-info"
            >
            <Tab eventKey="home" title="APPLICATION INFO" style={{background: "#ffff"}}>
                <Row style={{marginLeft: 25,marginRight: 25}}>
                    <Col xs={6} sm={6} style={{marginTop: 17}} className='thead-font label-style'>ID:</Col>
                    <Col xs={6} sm={6} style={{marginTop: 17}} className='tbody-font body'>{field_id}</Col>
                    <Col xs={6} sm={6} style={{marginTop: 6}} className='thead-font label-style'>STATUS:</Col>
                    <Col xs={6} sm={6} style={{marginTop: 6}} className='tbody-font body'>{StatusNomination[nominationStatus]}</Col>
                    <Col xs={6} sm={6} style={{marginTop: 6}} className='thead-font label-style'>ACADEMIC YEAR:</Col>
                    <Col xs={6} sm={6} style={{marginTop: 6}} className='tbody-font body'>{field_academic_year}</Col>
                    <Col xs={6} sm={6} style={{marginTop: 6}} className='thead-font label-style'>ACADEMIC TERM:</Col>
                    <Col xs={6} sm={6} style={{marginTop: 6}} className='tbody-font body'>{field_academic_term}</Col>
                    <Col xs={6} sm={6} style={{marginTop: 6,marginBottom: 25}} className='thead-font label-style'>SUBMISSION TIME:</Col>
                    <Col xs={6} sm={6} style={{marginTop: 6,marginBottom: 25}} className='tbody-font body'>{createdDate}</Col>
                    <Col xs={12} sm={12} style={{marginTop: 6,marginBottom: 15}} className='tbody-font body text-end'>
                    <Overlay
                            target={tooltipTarget.current}
                            show={showTooltip}
                            placement="top"
                        >
                            {(props) => (
                            <Tooltip
                                id="overlay-example"
                                {...props}
                                className="position-absolute"
                            >
                                    Download All Files
                            </Tooltip>
                            )}
                        </Overlay>
                        <div ref={tooltipTarget}>
                            <ExportZip id={field_id} onMouseEnter={handleShowTooltip} onMouseLeave={handleCloseTooltip} studentName={field_student_name}/>
                        </div>
                    </Col>
                </Row>
            </Tab>
            </Tabs>
        </Col>
        <Col style={{marginTop: 15, paddingLeft: 0, paddingRight: 0}} xs={12} sm={12}>
            <Tabs
            id="second-tab"
            >
            <Tab eventKey="general-info" id="general-info" title="General Info" style={{background: "#EAECF3"}}>
                <Row style={{marginLeft: 15, marginRight: 15}}>
                    <Col style={{marginTop: 20, marginBottom:38, paddingLeft: 0, paddingRight: 0}}>
                        <Tabs
                            defaultActiveKey="home"
                            id="student-info"
                        >
                            <Tab eventKey="home" title="STUDENT INFO" style={{background: "#ffff"}}>
                                <Row style={{marginLeft: 25,marginRight: 25}}>
                                    <Col xs={6} sm={6} style={{marginTop: 17}} className='thead-font label-style'>NAME:</Col>
                                    <Col xs={6} sm={6} style={{marginTop: 17}} className='tbody-font body'>{field_student_name}</Col>
                                    <Col xs={6} sm={6} style={{marginTop: 6}} className='thead-font label-style'>EMAIL:</Col>
                                    <Col xs={6} sm={6} style={{marginTop: 6}} className='tbody-font body'>{field_student_email}</Col>
                                    <Col xs={6} sm={6} style={{marginTop: 6}} className='thead-font label-style'>STUDY LEVEL:</Col>
                                    <Col xs={6} sm={6} style={{marginTop: 6}} className='tbody-font body'>{field_student_eqf}</Col>
                                    <Col xs={6} sm={6} style={{marginTop: 6, marginBottom: 25}} className='thead-font label-style'>STUDY FIELD:</Col>
                                    <Col xs={6} sm={6} style={{marginTop: 6, marginBottom: 25}} className='tbody-font body'>{field_student_isced}</Col>
                                    
                                </Row>
                            </Tab>
                        </Tabs>
                    </Col>
                </Row>
                <Row style={{marginLeft: 15, marginRight: 15}}>
                    <Col style={{marginTop: 20, marginBottom:38, paddingLeft: 0, paddingRight: 0}}>
                        <Tabs
                            defaultActiveKey="home"
                            id="destination-heis"
                        >
                            <Tab eventKey="home" title="DESTINATION HEIs" style={{background: "#ffff"}}>
                                {data.outgoingNomination?.field_mobility_details?.map((element, index) =>
                                <>
                                <div id='item-wrapper'>
                                    <DestinationHEIHeader size={size} mobilityDetail={element} academicYear={field_academic_year} isMobile/>
                                    <Accordion className='border-hidden' style={{marginBottom: 28}}>
                                        <Accordion.Item eventKey="0" className='border-hidden'>
                                            <Accordion.Header className='border-hidden' style={{marginBottom: 20}}>
                                            {element?.field_mobility_details_status === "active" ? 
                                                <Button style={{background: "#2B9436", borderRadius: 5, borderColor: "#2B9436"}} disabled> 
                                                NOMINATED
                                                </Button> : (element?.field_mobility_details_status === "rejected") || (element?.field_mobility_details_status === "old_rejected") ?
                                                <Button style={{background: "#B61717", borderRadius: 5, borderColor: "#B61717"}} disabled> 
                                                REJECTED
                                                </Button> :
                                                <CustomButton disabled={!element?.canBeAccepted} handleClick={() => {handleShowModalNominate(); setMobilityId(element?.id);}} 
                                                buttonType={"accept"} text={"Nominate"} small={true} icon={faCheck} hasIcon={true} iconColor={COLORS.white}/>
                                            }
                                            </Accordion.Header>
                                            <Accordion.Body className='border-hidden grey' style={{paddingTop: 0}}>
                                                <DestinationHEIInfo hostErasmusCode={element?.field_host_erasmus_code} isMobile/>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                                {data.outgoingNomination?.field_mobility_details.length - 1 !== index ?
                                 <hr style={{marginLeft: 18, marginRight: 20, marginBottom: 17, border: "2px solid #DDDDDD"}}/> : data.outgoingNomination?.field_mobility_details.length !== index && 
                                 <hr style={{marginLeft: 18, marginRight: 20, marginBottom: 17, border: "0px solid #DDDDDD"}}/>
                                 }
                                </>
                                )}
                            </Tab>
                        </Tabs>
                    </Col>
                </Row>
            </Tab>
            <Tab eventKey="documents" id="documents" title="Documents" style={{background: "#EAECF3"}}>
                <Row style={{marginLeft: 5, marginRight: 5}}>
                <Col style={{marginTop: 30, marginBottom: 12}} md={12} lg={12}>
                {(field_cv?.id) &&
                <>
                    <Col style={{marginBottom: 12, paddingRight: 3}} md={12} lg={12}>
                        <div className='document-item label-style'><span style={{float: "left", paddingLeft: 17}}>CV</span>
                            <div style={{marginBottom: 12, float: "right", marginRight: 5}}>
                                <a href={`/applications-for-erasmus+/outgoing-students/export/${field_cv?.id}`} target="_blank" rel="noreferrer">
                                    <CustomButton buttonType={"primary"} text={"View Pdf"} small={true} icon={faEye} hasIcon={true} iconColor={COLORS.white}/>
                                </a>
                            </div>
                        </div>
                    </Col>
                </>
                }

                {(field_portfolio?.id) &&
                <>
                    <Col style={{marginBottom: 12, paddingRight: 3}} md={12} lg={12}>
                        <div className='document-item label-style'><span style={{float: "left", paddingLeft: 17}}>PORTFOLIO</span>
                            <div style={{marginBottom: 12, float: "right", marginRight: 5}}>
                                <a href={`/applications-for-erasmus+/outgoing-students/export/${field_portfolio?.id}`} target="_blank" rel="noreferrer">
                                    <CustomButton buttonType={"primary"} text={"View Pdf"} small={true} icon={faEye} hasIcon={true} iconColor={COLORS.white}/>
                                </a>
                            </div>
                        </div>
                    </Col>
                </>
                }

                {(field_external_cert?.id) &&
                <>
                    <Col style={{marginBottom: 12, paddingRight: 3}} md={12} lg={12}>
                        <div className='document-item label-style'><span style={{float: "left", paddingLeft: 17}}>EXTERNAL CERTIFICATION</span>
                            <div style={{marginBottom: 12, float: "right", marginRight: 5}}>
                                <a href={`/applications-for-erasmus+/outgoing-students/export/${field_external_cert?.id}`} target="_blank" rel="noreferrer">
                                    <CustomButton buttonType={"primary"} text={"View Pdf"} small={true} icon={faEye} hasIcon={true} iconColor={COLORS.white}/>
                                </a>
                            </div>
                        </div>
                    </Col>
                </>
                }
                {(field_reference_contact?.id) && 
                <>
                    <Col style={{marginBottom: 12, paddingRight: 3}} md={12} lg={12}>
                        <div className='document-item label-style'><span style={{float: "left", paddingLeft: 17}}>REFERENCE CONTACT</span>
                            <div style={{marginBottom: 12, float: "right", marginRight: 5}}>
                                <a href={`/applications-for-erasmus+/outgoing-students/export/${field_reference_contact?.id}`} target="_blank" rel="noreferrer">
                                    <CustomButton buttonType={"primary"} text={"View Pdf"} small={true} icon={faEye} hasIcon={true} iconColor={COLORS.white}/>
                                </a>
                            </div>
                        </div>
                    </Col>
                </>
                }
                
                {(field_motivation_letter?.id) &&
                <>
                    <Col style={{marginBottom: 12, paddingRight: 3}} md={12} lg={12}>
                        <div className='document-item label-style'><span style={{float: "left", paddingLeft: 17}}>MOTIVATION LETTER</span>
                            <div style={{marginBottom: 12, float: "right", marginRight: 5}}>
                                <a href={`/applications-for-erasmus+/outgoing-students/export/${field_motivation_letter?.id}`} target="_blank" rel="noreferrer">
                                    <CustomButton buttonType={"primary"} text={"View Pdf"} small={true} icon={faEye} hasIcon={true} iconColor={COLORS.white}/>
                                </a>
                            </div>
                        </div>
                    </Col>
                </>
                }

                {(field_lang_level?.length > 0) &&
                <>
                    <Accordion className='border-hidden label-style' style={{marginBottom: 12}}>
                        <Accordion.Item eventKey="0" className='label-style'>
                            <Accordion.Header className='document-item label-style'>LANGUAGE CERTIFICATES</Accordion.Header>
                            <Accordion.Body className='border-hidden label-style'>
                                {field_lang_level.map((element, index) => 
                                <Col style={{marginBottom: 12, paddingRight: 3, background: "#F2F3F6"}} md={12} lg={12}>
                                <div className='document-language-item label-style'><span style={{float: "left", paddingLeft: 5}}>{element?.fileName}</span>
                                    <div style={{marginBottom: 12, float: "right", marginRight: 5}}>
                                        <a href={`/applications-for-erasmus+/outgoing-students/export/${element?.id}`} target="_blank" rel="noreferrer">
                                            <CustomButton buttonType={"primary"} text={"View Pdf"} small={true} icon={faEye} hasIcon={true} iconColor={COLORS.white}/>
                                        </a>
                                    </div>
                                </div>
                                </Col>
                                )}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </>
                }

                {(field_other_document?.length > 0) &&
                <>
                    <Accordion className='border-hidden label-style' style={{marginBottom: 12}}>
                        <Accordion.Item eventKey="0" className='label-style'>
                            <Accordion.Header className='document-item label-style'>OTHER DOCUMENTS</Accordion.Header>
                            <Accordion.Body className='border-hidden label-style'>
                                {field_other_document.map((element, index) => 
                                <Col style={{marginBottom: 12, paddingRight: 3, background: "#F2F3F6"}} md={12} lg={12}>
                                <div className='document-language-item label-style'><span style={{float: "left", paddingLeft: 5}}>{element?.fileName}</span>
                                    <div style={{marginBottom: 12, float: "right", marginRight: 5}}>
                                        <a href={`/applications-for-erasmus+/outgoing-students/export/${element?.id}`} target="_blank" rel="noreferrer">
                                            <CustomButton buttonType={"primary"} text={"View Pdf"} small={true} icon={faEye} hasIcon={true} iconColor={COLORS.white}/>
                                        </a>
                                    </div>
                                </div>
                                </Col>
                                )}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </>
                }
                </Col>
                </Row>
            </Tab>
            </Tabs>
        </Col>
        <Col style={{marginTop: 15, paddingLeft: 0, paddingRight: 0}} xs={6} sm={6}>
            <Button className='wrapper-waiting-mobile col-12' style={{display: "flex", justifyContent: "center"}} disabled={(nominationStatus === 'accepted_by_sending' 
            || nominationStatus === 'accepted_by_student' || nominationStatus === 'rejected_by_sending' || nominationStatus === 'cancelled' ) ? true : (nominationStatus === 'waiting_list') ? 
            true : (nominationStatus === 'rejected_by_student') ? true : false} onClick={handleShowModalWaiting}> 
                <span >
                    <FontAwesomeIcon
                    icon={faClipboardList}
                    color={COLORS.white}
                    className="button-waiting"
                    />
                </span>{t('waitingList')}
            </Button>
        </Col>
        <Col style={{marginTop: 15, paddingLeft: 5, display: "flex", justifyContent: "flex-end", paddingRight: 0}} xs={6} sm={6}>
            <Button className='wrapper-reject-mobile col-12' style={{display: "flex", justifyContent: "center"}} disabled={(nominationStatus === 'accepted_by_sending' 
            || nominationStatus === 'accepted_by_student' || nominationStatus === 'rejected_by_sending' || nominationStatus === 'cancelled' ) ? true : (nominationStatus === 'waiting_list') ? 
            false : (nominationStatus === 'rejected_by_student') ? true : false} onClick={handleShowModalReject}> 
                <span >
                    <FontAwesomeIcon
                    icon={faXmark}
                    color={COLORS.white}
                    className="button-waiting"
                    />
                </span>{t('reject')}
            </Button>
        </Col>
        <Col style={{marginTop: 15, paddingLeft: 0, paddingRight: 0}} xs={12} sm={12}>
            <Button className='wrapper-delete-mobile col-12' style={{display: "flex", justifyContent: "center"}} disabled={(nominationStatus === 'accepted_by_sending' 
            || nominationStatus === 'accepted_by_student' || nominationStatus === 'rejected_by_sending' || nominationStatus === 'cancelled' ) ? true : (nominationStatus === 'waiting_list') ? 
            false : (nominationStatus === 'rejected_by_student') ? false : false} onClick={handleShowModalDelete}> 
                <span >
                    <FontAwesomeIcon
                    icon={faTrash}
                    color={COLORS.white}
                    className="button-waiting"
                    />
                </span>{t('delete')}
            </Button>
        </Col>
    </Row>
    </>
  )}
    <CustomModal show={showModalReject}  handleClose={handleCloseModalReject} 
            body={t('modalReject.body')}
            button={<CustomButton buttonType={"decline"} text={t('modalReject.reject')}  icon={faXmark} disabled={loadingRejectNomination} hasIcon={true} iconColor={COLORS.white} handleClick={handleReject}/>} 
            title={<div>{t('modalReject.title.part1')}<span style={{color: "red"}}>{t('modalReject.title.part2')}</span>{t('modalReject.title.part3')}</div>} hasIcon={false} disabledCancelButton={loadingRejectNomination}/>

    <CustomModal show={showModalCancel}  handleClose={handleCloseModalCancel} 
            //body={"After canceling the nomination, the student will not be able to apply for any other mobility program in the current academic year."}
            button={<CustomButton buttonType={"delete"} text={"CONFIRM"}  icon={faXmark} disabled={loadingCancelNomination} iconColor={COLORS.white} handleClick={handleCancel}/>} 
            title={<div>{t('modalReject.title.part1')}<span style={{color: "red"}}>{"cancel"}</span>{" a student’s nomination"}</div>} hasCancelButton={false} disabledCancelButton={loadingCancelNomination}/>

    <CustomModal show={showModalWaiting}  handleClose={handleCloseModalWaiting} 
            body={t('modalWaiting.body')}
            button={<CustomButton buttonType={"primary"} text={t('modalWaiting.waitingList')} disabled={loadingWaitListNomination} icon={faClipboardList} hasIcon={true} iconColor={COLORS.white}  handleClick={handleWaitlist}/>} 
            title={<div>{t('modalWaiting.title.part1')}<span style={{color: "#3D619C"}}>{t('modalWaiting.title.part2')}</span></div>} hasIcon disabledCancelButton={loadingWaitListNomination}/>

    <CustomModal show={showModalDelete}  handleClose={handleCloseModalDelete} 
            body={t('modalDelete.body')}
            button={<CustomButton buttonType={"delete"} text={t('modalDelete.delete')}  icon={faTrash} disabled={loadingDeleteNomination} hasIcon={true} iconColor={COLORS.white}  handleClick={handleDelete}/>} 
            title={<div>{t('modalDelete.title.part1')}<span style={{color: "red"}}>{t('modalDelete.title.part2')}</span>{t('modalDelete.title.part3')}</div>} hasIcon disabledCancelButton={loadingDeleteNomination}/>
    <CustomModal show={showModalNominate}  handleClose={handleCloseModalNominate} 
            body={t('modalNominate.body')}
            button={<CustomButton buttonType={"accept"} text={t('modalNominate.nominate')}  icon={faCheck} disabled={loadingActivateDestination} hasIcon={true} iconColor={COLORS.white}  handleClick={handleNominate}/>} 
            title={<div>{t('modalNominate.title.part1')}<span style={{color: "green"}}>{t('modalNominate.title.part2')}</span>{t('modalNominate.title.part3')}</div>} hasIcon disabledCancelButton={loadingActivateDestination}/>
    <CustomModal 
                show={showModalEdit}  
                handleClose={handleCloseModalEdit} 
                body={editModalBody}
                button={
                    <CustomButton 
                        buttonType={"accept"} 
                        text={"Save Changes"}  
                        handleClick={handleSaveChanges}
                        disabled={!isFormValid || loadingEditNomination}
                    />
                } 
                title={<div>Edit <span style={{color: "#3D619C"}}>Nomination</span> Details</div>} 
                fullscreen={false}
                size="lg"
            />
    <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
  </>)
};

export default withFooter(
    withNavBar(SingleViewOutgoingNominations, "Nominations for Erasmus+", "Outgoing Students")
);